const ClockIcon = ({ height = 14, width = 14 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 5.125V2.5C2 2.225 1.775 2 1.5 2C1.225 2 1 2.225 1 2.5V6.5C1 6.775 1.225 7 1.5 7H5.5C5.775 7 6 6.775 6 6.5C6 6.225 5.775 6 5.5 6H2.675C3.79688 3.63438 6.20937 2 9 2C12.8656 2 16 5.13438 16 9C16 12.8656 12.8656 16 9 16C6.70937 16 4.67813 14.9 3.4 13.2C3.23438 12.9781 2.92188 12.9344 2.7 13.1C2.47813 13.2656 2.43438 13.5781 2.6 13.8C4.05938 15.7438 6.38125 17 9 17C13.4187 17 17 13.4187 17 9C17 4.58125 13.4187 1 9 1C5.9875 1 3.36562 2.66563 2 5.125ZM9 5C8.725 5 8.5 5.225 8.5 5.5V9C8.5 9.13125 8.55312 9.25937 8.64687 9.35312L11.1469 11.8531C11.3406 12.0469 11.6594 12.0469 11.8531 11.8531C12.0469 11.6594 12.0469 11.3406 11.8531 11.1469L9.5 8.79375V5.5C9.5 5.225 9.275 5 9 5Z"
      fill="grey"
    />
  </svg>
);
export default ClockIcon;
